import { ServiceScheduleFormModel } from "../typings/models";
import { DateTime } from "luxon";
import { DATE_FORMAT } from "./date";

export const FORM_DEFAULT_VALUES: ServiceScheduleFormModel = {
  name: '',
  email: '',
  phone: '',
  date: DateTime.now().toFormat(DATE_FORMAT),
  time: '',
  vehicle: '',
  works: '',
};

